module.exports = __webpack_public_path__ + "media/fonts/PPNeueMontreal-Bold-7a5b9cad.otf";